import React from 'react';

const ErrorsList = ({ error, showFirstOnly = false, style = {} }) => {
	const isString = typeof error === 'string';
	const isArray = Array.isArray(error) && error.length;
	if (isString) return <small className="error">{error}</small>;
	if (isArray && showFirstOnly) return <small className="error" style={style}>{error[0]}</small>;
	else if (isArray)
		return error.length ? (
			<div style={{ marginTop: 5 }}>
				{error.map(e => (e ? <small className="error" style={style}>{e}</small> : null))}
			</div>
		) : null;
	return null;
};

export default ErrorsList;
